import { useLocation } from "react-router";

export function useStudyPlanBackPath(courseId) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const studyPlanCourseId =
    params.get("study-plan") ||
    (params.get("source") === "study-plan" ? courseId : null);

  return {
    backTo: studyPlanCourseId
      ? `/courses/${studyPlanCourseId}?tab=study-plan`
      : null,
    backLabel: studyPlanCourseId
      ? "Voltar para Plano de Estudos"
      : null,
  };
}
